export const AddLocationHeader = (): JSX.Element => {
    return (
        <div>
            <div className="has-text-weight-bold">Add a location</div>
            <div>Enter the new location’s name and address below</div>
        </div>
    );
};
